import useModule from "../../hooks/useModule";
import useFieldMap from "../../hooks/useFieldMap";
import ManageItems from "../ManageItems/ManageItems";
import { CheckPicker } from "rsuite";

interface Props {
  fields: string[];
  onFieldUpdate: (newFields: string[]) => void;
  moduleAPIName: string;
}

const SubModuleFields = ({ fields, onFieldUpdate, moduleAPIName }: Props) => {
  const { module } = useModule(moduleAPIName);
  const fieldNameMap = useFieldMap(moduleAPIName, "Name");

  if (!fields || !moduleAPIName) {
    return <h5 className="text-center mt-2">Select a Data Source</h5>;
  }

  return (
    <>
      <CheckPicker
        data={
          Array.isArray(module?.Fields)
            ? module?.Fields?.filter(
                (f) => !["_RecordName", "id", "_id"].includes(f?.APIName)
              )
            : []
        }
        labelKey="Name"
        valueKey="APIName"
        style={{ width: "100%" }}
        placeholder="Select your fields"
        onChange={handleUpdateFields}
        value={fields}
        block
        className="mb-4"
      />
      <ManageItems
        items={fields.filter((field) => !["_RecordName", "id"].includes(field))}
        itemKey={undefined}
        isStringArray={true}
        onReorder={handleFieldReorder}
        onDelete={handleDeleteField}
        itemNameMap={fieldNameMap}
      />
    </>
  );

  function handleUpdateFields(newFields: string[] | null) {
    const finalFields =
      !newFields || !newFields.length ? ["_RecordName", "id"] : newFields;

    onFieldUpdate(finalFields);
  }

  function handleDeleteField({ id: fieldAPIName }: { id: string }) {
    const newFields = fields.filter((field) => field !== fieldAPIName);

    onFieldUpdate(newFields);
  }

  function handleFieldReorder({ newOrder }: { newOrder: string[] }) {
    onFieldUpdate(["_RecordName", "id", ...newOrder]);
  }
};

export default SubModuleFields;
